import { Box, Button, Dialog, Heading, Text } from '@betterment/samba-react';

const VerificationCheckFailedDialog = ({
  isOpen,
  setIsOpen,
}: {
  isOpen: boolean;
  setIsOpen: (arg0: boolean) => void;
}) => (
  <Dialog open={isOpen} onOpenChange={setIsOpen}>
    <Dialog.Content size="large">
      <Box
        css={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          padding: 'space.400',
          gap: 'space.200',
        }}
      >
        <Dialog.Title asChild={true}>
          <Heading variant="title300">Please verify your email address</Heading>
        </Dialog.Title>
        <Dialog.Description asChild={true}>
          <Text as="p">
            You can’t proceed until you verify your email. Open the link in your email or resend it to complete
            verification.
          </Text>
        </Dialog.Description>
        <Button onClick={() => setIsOpen(false)}>Got it</Button>
      </Box>
    </Dialog.Content>
  </Dialog>
);

export default VerificationCheckFailedDialog;
